import React, { useMemo } from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import { Check, X } from "lucide-react";
import {
  evaluatePasswordStrength,
  PASSWORD_REQUIREMENTS,
  STRENGTH_COLORS,
  STRENGTH_LABELS,
} from "../utils/passwordPolicy";

const strengthProgress = {
  weak: 25,
  fair: 50,
  good: 75,
  strong: 100,
};

const PasswordStrengthPanel = ({ password = "", confirmPassword = "" }) => {
  const evaluation = useMemo(() => evaluatePasswordStrength(password), [password]);
  const passwordsMatch =
    !confirmPassword || !password || password === confirmPassword;

  return (
    <Box
      sx={{
        border: "1px solid #e4e7ec",
        borderRadius: 2,
        p: 1.5,
        bgcolor: "#f8fafc",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.75 }}>
        <Typography variant="caption" sx={{ fontWeight: 700, color: "#475467" }}>
          Força da senha
        </Typography>
        <Typography
          variant="caption"
          sx={{ fontWeight: 700, color: STRENGTH_COLORS[evaluation.strength] }}
        >
          {password ? STRENGTH_LABELS[evaluation.strength] : "—"}
        </Typography>
      </Box>

      <LinearProgress
        variant="determinate"
        value={password ? strengthProgress[evaluation.strength] : 0}
        sx={{
          height: 8,
          borderRadius: 999,
          mb: 1.5,
          bgcolor: "#e5e7eb",
          "& .MuiLinearProgress-bar": {
            borderRadius: 999,
            bgcolor: STRENGTH_COLORS[evaluation.strength],
          },
        }}
      />

      <Box component="ul" sx={{ m: 0, p: 0, listStyle: "none", display: "grid", gap: 0.5 }}>
        {PASSWORD_REQUIREMENTS.map((rule) => {
          const ok = evaluation.checks[rule.id];
          return (
            <Box
              component="li"
              key={rule.id}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                color: ok ? "#15803d" : "#667085",
                fontSize: 12,
              }}
            >
              {ok ? <Check size={14} /> : <X size={14} />}
              <span>{rule.label}</span>
            </Box>
          );
        })}
      </Box>

      {confirmPassword && !passwordsMatch && (
        <Typography variant="caption" sx={{ display: "block", mt: 1, color: "#dc2626" }}>
          As senhas não conferem.
        </Typography>
      )}
    </Box>
  );
};

export default PasswordStrengthPanel;
